import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Messages from './Messages';
import s from './HistoryEventsFilterbox.css';
import {getReserveData} from './utils';
import { getDataFilterboxSoftener, getDataFilterboxSuperior } from './utils';

class HistoryEventsFilterbox extends React.Component {
  setFilter = (name, deviceType) => {
    this.props.setDeviceDocumentFilter('events', name, deviceType);
  };

  setColumnFilter = (name, deviceType, screenType) => {
    this.props.setDeviceDocumentColumnFilter(
      'events',
      name,
      deviceType,
      screenType
    );
  };

  getElement = (item, index, deviceType, filter) => {
    const value = filter.get(item.name);
    const checked = +value === 1;
    return (
      <div key={index}>
        <input
          type="checkbox"
          name={item.name}
          value={value}
          onChange={this.setFilter.bind(this, item.name, deviceType)}
          checked={checked}
        />
        <label htmlFor={item.name}>
          <FormattedMessage {...item.text} />
        </label>
      </div>
    );
  };

  getColumn = (column, index, deviceType, columnStyle, filter) => {
    return (
      <td key={index} className={columnStyle}>
        <span>
          {column.map((item, ind) => 
            this.getElement(item, ind, deviceType, filter),
          )}
        </span>
      </td>
    );
  };

  getColumnHeader = (item, index, deviceType, filter, screenType) => {
    const value = filter.get(item.name);
    const checked = +value === 1;
    switch (deviceType) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        return (
          <th className={cx(s.header)} key={index}>
            <input
              type="checkbox"
              name={item.name}
              value={value}
              onChange={this.setColumnFilter.bind(
                this,
                item.name,
                deviceType,
                screenType,
              )}
              checked={checked}
            />
            <FormattedMessage {...item.text} />
          </th>
        );
      case 'superior':
        return (
          <th className={cx(s.spirotech)} key={index}>
            <input
              type="checkbox"
              name={item.name}
              value={value}
              onChange={this.setColumnFilter.bind(this, item.name, deviceType)}
              checked={checked}
            />
            <FormattedMessage {...item.text} />
          </th>
        );
      default:
        break;
    }
    return null;
  };

 

  getData = (messages, deviceType, screenType) => {
    const { documentSoftenerFilter, documentSuperiorFilter } = this.props;
    let data = [];
    let filter = null;
    switch (deviceType) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        data = getDataFilterboxSoftener(
          documentSoftenerFilter,
          messages, 
          screenType
        );
        filter = documentSoftenerFilter;
        break;
      case 'superior':
        data = getDataFilterboxSuperior(documentSuperiorFilter, messages);
        filter = documentSuperiorFilter;
        break;
      default:
        break;
    }
    return { data, filter }
  };

  getHeaderData = (messages, deviceType) => {
    let data = [];
    switch (deviceType) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        data = [
          {
            text: messages.history_events_header_time,
            name: 'times',
          },
          {
            text: messages.history_events_header_flows,
            name: 'flows',
          },
          {
            text: messages.history_events_header_pressure,
            name: 'pressure',
          },
          {
            text: messages.history_events_header_regenerations,
            name: 'regenerations',
          },
          {
            text: messages.history_events_header_cylinder_reserve,
            name: 'reserve',
          },
          {
            text: messages.history_events_header_network,
            name: 'network',
          },
        ];
        break;
      case 'superior':
        data = [
          {
            text: messages.history_events_superior_header_time,
            name: 'times',
          },
          {
            text: messages.history_events_superior_header_flow,
            name: 'flows',
          },
          {
            text: messages.history_events_superior_header_other,
            name: 'other',
          },
        ];
        break;
      default:
        break;
    }
    return data;
  };


  getColumnStyle = deviceType => {
    let columnStyle = cx();
    switch (deviceType) { 
      case 'softener':
      case 'charlie':
      case 'simplex':
        columnStyle = cx(s.column_softener, s.table_border);
        break;
      case 'superior':
        columnStyle = cx(s.column_superior, s.table_border);
        break;
      default:
        break;
    }
    return columnStyle;
  };


  render() {
    const messages = Messages();
    const { deviceDocument } = this.props;
    const deviceType = deviceDocument.get('deviceType');
    const screenType = deviceDocument.get('screenType');
    const { data, filter } = this.getData(messages, deviceType, screenType);
    const columnStyle = this.getColumnStyle(deviceType);
    const headerData = this.getHeaderData(messages, deviceType);
    return (
      <table className={s.Table_container}>
        <thead>
          <tr>
            {headerData.map((item, index) =>
              this.getColumnHeader(item, index, deviceType, filter, screenType),
            )}
          </tr>
        </thead>
        <tbody>
          <tr>
            {data.map((item, index) =>
              this.getColumn(item, index, deviceType, columnStyle, filter),
            )}
          </tr>
        </tbody>
      </table>
    );
  }
}

HistoryEventsFilterbox.propTypes = {
  deviceDocument: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSoftenerFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSuperiorFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  setDeviceDocumentFilter: PropTypes.func.isRequired,
  setDeviceDocumentColumnFilter: PropTypes.func.isRequired,
};

export default withStyles(s)(HistoryEventsFilterbox);



// WEBPACK FOOTER //
// ./src/components/HistoryEvents/HistoryEventsFilterboxView.js